export default "-- ClickBench Q1\nselect count(*)\nfrom hits\nwhere advengineid <> 0;";